import { ICategories } from "@types";
import { BaseAPI } from "@utils";

class CategoriesApi extends BaseAPI<ICategories> {}

export const categoriesApi = new CategoriesApi("/api/v1/categories");
